import InvasiveServiceInfo from 'src/components/common/InvasiveServiceInfo/InvasiveServiceInfo.vue'
import Vue from 'vue'
import vuetify from 'www/modules/vuetify-plugin'
import { pinia } from 'www/plugins'

const el = document.querySelector('.vue-invasive-service-info-mount')

if (el) {
  new Vue({
    vuetify,
    el,
    pinia,
    render: h => h(InvasiveServiceInfo),
  })
}
